import a from "react";
import { I as d } from "./Icon-BuIPTPJn.es.js";
import { T as u, c as g, d as i } from "./index-Dd-4N6BE.es.js";
import { u as y } from "./DarkModeProvider-xoZXm3ct.es.js";
import { u as T } from "./ThemeProvider--i7ESlT5.es.js";
const l = (o, e) => {
  e ? window.open(o, "_blank") : window.location.href = o;
}, E = (o, e, r) => e ? typeof e == "string" ? (t) => {
  t.stopPropagation(), l(e, o);
} : (t) => {
  t.stopPropagation(), t.preventDefault(), e(t), r && l(r, o);
} : (t) => t.stopPropagation(), _ = {
  default: i,
  compere: g
}, S = ({
  children: o,
  onClick: e,
  href: r,
  iconName: t = "open_tab",
  openInNewTab: m = !1,
  iconStyles: p = {}
}) => {
  const c = y(), f = T(), n = _[f] || i;
  let s = typeof e == "string" ? e : "";
  return r && (s = r), /* @__PURE__ */ a.createElement(u.Body2, { responsive: !0, tagName: "span" }, /* @__PURE__ */ a.createElement("b", null, /* @__PURE__ */ a.createElement("a", { href: s, onClick: E(m, e) }, o, /* @__PURE__ */ a.createElement(
    d,
    {
      testId: "list-card-link-icon",
      name: t,
      size: 20,
      style: { verticalAlign: "bottom", ...p },
      color: c ? n.darkLinkColor : n.lightLinkColor
    }
  ))));
};
export {
  S as L,
  E as g
};
